module.exports = __webpack_public_path__ + "static/media/the-game-cricket-2025-tn.ed105bc0.png";